import React, { Component } from "react";
import smoothscroll from "smoothscroll-polyfill";
import ReactGA from "react-ga";
import Logo from "./Logo.js";
import Modal from "./Modal.js";
import SignInOptions from "./SignInOptions.js";
import CopyToClipboard from "./CopyToClipboard.js";
import { blogPosts } from "../shared/_constants.js";
import "./Marketing.css";
import concernsBoard from "../concerns-board.svg";
import arrow from "../arrow.svg";
import concernsIllustration from "../concerns-illustration.svg";
import kudosIllustration from "../kudos-illustration.svg";
import ownersIllustration from "../owners-illustration.svg";
import profileTaylor from "../profile-taylor.JPG";
import profileDanny from "../profile-danny.JPG";

class Marketing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      closestContentNavIndex: 0,
      showSignInModal: false,
      copyToClipboard: false
    };

    this.whyOutroRefString = "whyOutroRef";
    this.formatRefString = "formatRef";
    this.makersRefString = "makersRef";
    this.pricingRefString = "pricingRef";
    this.SECTIONS = [
      {
        domRefString: this.whyOutroRefString,
        content: "Why Outro",
        domRef: undefined
      },
      {
        domRefString: this.formatRefString,
        content: "Meeting Format",
        domRef: undefined
      },
      {
        domRefString: this.makersRefString,
        content: "Our Story",
        domRef: undefined
      },
      {
        domRefString: this.pricingRefString,
        content: "Pricing",
        domRef: undefined
      }
    ];
  }

  componentDidMount() {
    this.SECTIONS[0].domRef = this.refs.whyOutroRef;
    this.SECTIONS[1].domRef = this.refs.formatRef;
    this.SECTIONS[2].domRef = this.refs.makersRef;
    this.SECTIONS[3].domRef = this.refs.pricingRef;

    //Provides smooth scrolling support for Safari and other browsers
    smoothscroll.polyfill();

    window.addEventListener("scroll", this.handleScroll, { passive: true });

    ReactGA.pageview("/", "Outro Marketing Page");
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  openCloseSignInModal = bool => {
    this.setState({
      showSignInModal: bool
    });
  };

  calculateDivDistance = section => {
    let middleFromTop = window.innerHeight / 2;

    if (section.domRef) {
      let divFromTop = section.domRef.getBoundingClientRect().top;
      let distance = middleFromTop - divFromTop;

      return distance;
    } else {
      return 0;
    }
  };

  calculateClosestContentNavIndex = () => {
    let sectionDistances = this.SECTIONS.map(section => {
      return this.calculateDivDistance(section);
    });

    let positiveDistances = [];
    sectionDistances.forEach((distance, index) => {
      if (distance > 0) {
        positiveDistances.push(distance);
      }
    });

    if (positiveDistances.length > 0) {
      return sectionDistances.indexOf(Math.min(...positiveDistances));
    } else {
      return 0;
    }
  };

  handleScroll = () => {
    let closestContentNavIndex = this.calculateClosestContentNavIndex();
    this.setState({ closestContentNavIndex: closestContentNavIndex });
  };

  scrollToContent = navIndex => {
    if (navIndex === 0) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    } else {
      this.SECTIONS[navIndex].domRef.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  };

  handleOpenSignUpModal = source => {
    this.openCloseSignInModal(true);

    ReactGA.event({
      category: "Marketing",
      action: "Opens Signup Modal"
    });
  };

  copyToClipboard = () => {
    this.setState({
      copyToClipboard: true
    });

    setTimeout(() => {
      this.setState({
        copyToClipboard: false
      });
    }, 5000);
  };

  renderNavItem = ({ domRef, content, navIndex }) => {
    let classString = "nav-item";
    if (navIndex === this.state.closestContentNavIndex) {
      classString += " active";
    }

    return (
      <li key={`li-${navIndex}`}>
        <div
          className={classString}
          onClick={() => this.scrollToContent(navIndex)}
        >
          {content}
        </div>
      </li>
    );
  };

  renderNav = () => {
    return (
      <div className="nav">
        <ul>
          {this.SECTIONS.map((section, index) => {
            return this.renderNavItem({
              section: section.domRef,
              content: section.content,
              navIndex: index
            });
          })}
        </ul>
        <div className="footer">
          <CopyToClipboard copyToClipboard={this.state.copyToClipboard} />
          <span className="contact" onClick={this.copyToClipboard}>
            hello@outro.co
          </span>
          <span className="spacer"> | </span>
          <a
            href="https://www.google.com/maps/place/Williamsburg,+Brooklyn,+NY/@40.7115538,-73.9706811,14z/data=!3m1!4b1!4m5!3m4!1s0x89c25bfd06c12a41:0x8279f2291cc5d76c!8m2!3d40.7081156!4d-73.9570696"
            target="_blank"
            rel="noopener noreferrer"
            className="madeinnyc"
          >
            Made in NYC <i className="fas fa-heart" />
          </a>
          <span className="spacer"> | </span>
          <a
            href="/privacy-tos"
            target="_blank"
            rel="noopener noreferrer"
            className="privacy-tos"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div>
        <Modal
          showSignInModal={this.state.showSignInModal}
          openCloseSignInModal={this.openCloseSignInModal}
        >
          <SignInOptions />
        </Modal>
        <div className="page-container">
          <div className="header">
            <Logo />
            <div
              className="sign-in"
              onClick={() => this.handleOpenSignUpModal("sign-in")}
            >
              sign in
            </div>
          </div>
          <div className="content-container">
            <div className="left-container">
              <h1 className="sentence">
                A new take <br className="linebreak" />
                on retrospectives* <br className="linebreak" />
                for progressive teams.
              </h1>
              <div className="cta-container">
                <div
                  className="cta"
                  onClick={() => this.handleOpenSignUpModal("join-us")}
                >
                  JOIN US <img src={arrow} alt="arrow" />
                </div>
              </div>
              <div className="hero-image-container">
                <img
                  src={concernsBoard}
                  alt="retrospective concerns board"
                  className="hero-image"
                />
              </div>
              {this.renderNav()}
            </div>
            <div className="right-container">
              <div
                className="why-outro content-section"
                ref={this.whyOutroRefString}
              >
                <h2 className="why">
                  <span>*A retrospective</span> is a candid, team-wide
                  discussion about how the team is doing, both the
                  accomplishments and the challenges. When done right, it
                  creates more effective, more close-knit teams.
                </h2>
                <div className="why-not">
                  <div className="content-headline">
                    Why Outro
                    <hr />
                  </div>
                  <div className="content-label">
                    A dedicated place for positivity
                  </div>
                  <div className="content">
                    We recognize individual team members for their recent
                    accomplishments. It goes a long way.
                    <hr />
                  </div>
                  <div className="content-label">A culture of improvement</div>
                  <div className="content">
                    We make small, iterative improvements after every retro that
                    add up quickly.
                    <hr />
                  </div>
                  <div className="content-label">End on a high note</div>
                  <div className="content">
                    We end our week/sprint/month/whatever together as a team, in
                    celebration.
                    <hr />
                  </div>
                  <div className="content-cta-container">
                    <span
                      onClick={() =>
                        this.handleOpenSignUpModal("sign-up-already")
                      }
                    >
                      Try it for free <img src={arrow} alt="arrow" />
                    </span>
                  </div>
                </div>
              </div>
              <div
                className="format content-section"
                ref={this.formatRefString}
              >
                <div className="content-headline">
                  Meeting Format
                  <hr />
                </div>
                <div className="content-label">Kudos</div>
                <div className="content">
                  Give shout-outs to team members for doing something positive.
                  <div className="content-image-container">
                    <img
                      src={kudosIllustration}
                      alt="kudos illustration"
                      className="content-image"
                    />
                  </div>
                  <div className="quote">
                    “Kudos to Maddy for the killer presentation you gave to the
                    company. Everyone loved it.”
                  </div>
                  <hr />
                </div>
                <div className="content-label">Concerns</div>
                <div className="content">
                  Share concerns with the team to discuss, keep track of, and
                  ultimately resolve.
                  <div className="content-image-container">
                    <img
                      src={concernsIllustration}
                      alt="concerns illustration"
                      className="content-image"
                    />
                  </div>
                  <div className="quote">
                    "I'm concerned we're not getting enough customer feedback
                    before we launch. How do we know if they'll like it?"
                  </div>
                  <hr />
                </div>
                <div className="content-label">Owners</div>
                <div className="content">
                  Assign owners and next steps to concerns so they can be
                  resolved more quickly.
                  <div className="content-image-container">
                    <img
                      src={ownersIllustration}
                      alt="owners illustration"
                      className="content-image"
                    />
                  </div>
                  <div className="quote">
                    “Kyle to organize a group of friend-and-family beta testers
                    before launch.”
                  </div>
                  <hr />
                  <div className="content-cta-container">
                    <a
                      href={blogPosts.resetOnRetros}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => {
                        ReactGA.event({
                          category: "Marketing",
                          action: "Opens Outro Format Blog Post"
                        });
                      }}
                    >
                      Read our retro guide <img src={arrow} alt="arrow" />
                    </a>
                  </div>
                </div>
              </div>
              <div
                className="makers content-section"
                ref={this.makersRefString}
              >
                <div className="content-headline">
                  Our Story
                  <hr />
                </div>
                <div className="content-label">The Mission</div>
                <div className="content">
                  To introduce retrospectives to every team at every company in
                  every industry. We want to bring retros to the mainstream,
                  where they belong.
                  <hr />
                </div>
                <div className="content-label">Meet the Makers</div>
                <div className="content">
                  Outro was created with <i className="fas fa-heart" /> in NYC
                  by{" "}
                  <a
                    href="https://twitter.com/taykcrane"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Taylor Crane
                  </a>{" "}
                  &{" "}
                  <a
                    href="https://twitter.com/dannypirajan"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Danny Pirajan
                  </a>
                  . We’ve hosted retros weekly since 2011 (across many teams),
                  and have seen over and over again the positive change it
                  creates. This compelled us to turn what we love about retros
                  into a beautiful product for any team to use.
                  <div className="content-image-container">
                    <img
                      src={profileTaylor}
                      alt="taylor crane profile"
                      className="content-image"
                    />
                    <img
                      src={profileDanny}
                      alt="danny pirajan profile"
                      className="content-image"
                    />
                  </div>
                  <hr />
                </div>
                <div className="content-cta-container">
                  <a
                    href={blogPosts.introToOutro}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      ReactGA.event({
                        category: "Marketing",
                        action: "Opens Outro Story Blog Post"
                      });
                    }}
                  >
                    Read our story <img src={arrow} alt="arrow" />
                  </a>
                </div>
              </div>
              <div
                className="pricing content-section"
                ref={this.pricingRefString}
              >
                <div className="content-headline">
                  Pricing
                  <hr />
                </div>
                <div className="content-label">It's free to try!</div>
                <div className="content">
                  After four retros, we ask for $10/month for your entire team
                  (no user-based pricing).
                  <hr />
                </div>
                <div className="content-label">Wait - why isn't this free?</div>
                <div className="content">
                  Because your support is important! Outro is a passion project
                  that we dedicated our free time to. Needless to say, we think
                  it’s worth trying. Once you & your team see the value in it,
                  then you can upgrade. Fair deal?
                  <hr />
                </div>
                <div className="content-cta-container">
                  <span
                    onClick={() => this.handleOpenSignUpModal("one-last-time")}
                  >
                    Welcome to Outro <img src={arrow} alt="arrow" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Marketing;



// WEBPACK FOOTER //
// ./src/components/Marketing.js